module.exports = __webpack_public_path__ + "static/media/DeathSurgeInd.fe331907.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/DeathSurgeInd.png
// module id = 330
// module chunks = 0